import React from 'react'
import { IconProps } from './icons.types'

export const Cards: React.FC<IconProps> = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 18"
    fill="none"
  >
    <path
      d="M3.75 2.75H2.75C1.64543 2.75 0.75 3.64543 0.75 4.75V12.75C0.75 13.8546 1.64543 14.75 2.75 14.75H3.75M19.75 2.75H20.75C21.8546 2.75 22.75 3.64543 22.75 4.75V12.75C22.75 13.8546 21.8546 14.75 20.75 14.75H19.75M8.75 16.75H14.75C15.8546 16.75 16.75 15.8546 16.75 14.75V2.75C16.75 1.64543 15.8546 0.75 14.75 0.75H8.75C7.64543 0.75 6.75 1.64543 6.75 2.75V14.75C6.75 15.8546 7.64543 16.75 8.75 16.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
